export const CHARTS_TYPE_ENUM = {
  LINE: 0,
  BAR: 1,
  DOUGHNUT: 2
};

export const PERIODIC_REPORT_TYPE = {
  AVERAGE: 1,
  TOP: 2
};

export const TOP_CHART_SERIE = {
  TOP_3: "top3",
  TOP_10: "top10",
  TOP_20: "top20"
};
